import React from "react";
import { connect } from "react-redux";

class AccountLedgerFilter extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone
		}
    }


    componentDidMount(){

	}
	componentWillUnmount(){
    }

  
    render(){

    return(
        <div class="hisfltr">
        <div class="dropdown filbox">
            <button type="button" class="dropdown-toggle fltrbtn" 
            data-bs-auto-close="outside" id="fltrid" data-bs-toggle="dropdown"
             aria-expanded="false" aria-haspopup="true"></button>
        
            <div class="dropdown-menu dropdown-menu-end" aria-labelledby="fltrid">
                <form>
                    <div class="filters">
                        <label for="select-state">Type:</label>
                        <select ata-placeholder="..." multiple 
                        class="chosen-select"
                        onChange={this.typeSelect}>
                                {this.state.types.map(type=>(
                                <option value={type.value}
                                >{type.value}</option>
                                ))}
                        </select>
                        
                    </div>

                    <div class="filters">
                        <label for="select-state">From:</label>
                        <input type="date" name="" placeholder="DD/MM/YYYY" 
                        onChange={this.selectFromDate}/>
                    </div>
                    <div class="filters">
                        <label for="select-state">To:</label>
                        <input type="date" name="" placeholder="DD/MM/YYYY"
                        onChange={this.selectToDate}/>
                    </div>												
                    <div class="filters">
                        <button type="reset" class="clear" id="btnClear"
                        onClick={this.reset}>Clear</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(AccountLedgerFilter);
